import * as React from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import BackgroundSvg from '../assets/background.svg';

export type alerttype = 'default'|'black'|'white'|'primary'|'secondary'|'success'|'info'|'warning'|'error';
export type align = 'left'|'center'|'right'|'space-between';
export type size = 'small'|'medium'|'large';
export type maxwidth = 'xl'|'lg'|'md'|'sm'|'xs';
export type direction = 'row'|'row-reverse'|'column'|'column-reverse';
export type position = 'center'|'top'|'bottom'|'left'|'right'|'topLeft'|'topRight'|'bottomRight'|'bottomLeft';
export type textsize = 'supersmall'|'extrasmall'|'small'|'medium'|'large'|'extralarge'|'superlarge'|'superextralarge'|'maxlarge';
export type textalign = 'left'|'center'|'right'|'justify';
export type transition = 'hideOnScroll'|'slide'|'fade'|'zoom'|'grow'|'growLeft';

export default class AppService {

//Apps
    public static appId() {
        return `${process.env.REACT_APP_APP_ID}` ;  
    } 

    public static isAppFullVersion() {
        return this.appId() === '1';
    }
    
    public static isMobile() {
        return window.screen.width < 485;//window.matchMedia && window.matchMedia('(max-width: 485px)').matches;
    }
    
    public static isMac() {
        return /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);
    }

    public static pathDashboard = '/dashboard';

    public static historyState(fieldName?: string, value?: any, isCheckZero?: boolean, isCheckExist?: boolean) {
        var historyState: any = window.history.state;
        
        if (fieldName && (value || (isCheckZero && (value >= 0 || !value))) 
            && (historyState?.state?.[fieldName] !== value)
            && (!isCheckExist || (isCheckExist && !historyState?.state?.[fieldName])))
            window.history.replaceState({...historyState, state: {...historyState?.state, [fieldName]: value}}, '');
        
        return window.history.state?.state;
    }

    public static getUrlQuery(history: any, name?: string) {
        if (!history?.location.search) return;
        const urlQuery = history.location.search.substring(1).split('&').map((d: any) => {return {[d.split('=')[0]]: d.split('=')[1]}});
            
        return !!name? urlQuery?.find((d: any) => d?.[name])?.[name] : urlQuery;
    }

    public static openLink(path?: string) {
        if (path) window.open(path);
    }

//Date
    public static optionDay = [
        { name: 'sun', caption: 'Minggu' },
        { name: 'mon', caption: 'Senin' },
        { name: 'tue', caption: 'Selasa' },
        { name: 'wed', caption: 'Rabu' },
        { name: 'thu', caption: 'Kamis' },
        { name: 'fri', caption: 'Jumat' },
        { name: 'sat', caption: 'Sabtu' },
    ]

    public static optionMonth = [
        { name: 'jan', caption: 'Januari', captionshort: 'Jan' },
        { name: 'feb', caption: 'February', captionshort: 'Feb' },
        { name: 'mar', caption: 'Maret', captionshort: 'Mar' },
        { name: 'apr', caption: 'April', captionshort: 'Apr' },
        { name: 'may', caption: 'May', captionshort: 'Mei' },
        { name: 'jun', caption: 'Juni', captionshort: 'Jun' },
        { name: 'jul', caption: 'Juli' , captionshort: 'Jul'},
        { name: 'agu', caption: 'Agustus', captionshort: 'Agu' },
        { name: 'sep', caption: 'September', captionshort: 'Sep'},
        { name: 'oct', caption: 'Oktober', captionshort: 'Okt' },
        { name: 'nov', caption: 'November', captionshort: 'Nov' },
        { name: 'dec', caption: 'Desember', captionshort: 'Des' },
    ]

    public static days(fieldName: string) {
        return this.optionDay.reduce((r: any, d: any) =>  {r.push(d[fieldName]); return r}, [] );
    }

    public static months(fieldName: string) {
        return this.optionMonth.reduce((r: any, d: any) =>  {r.push(d[fieldName]); return r}, [] );
    }

    public static dateCurrent() {
        const date = new Date();
        return date.toLocaleDateString('en-CA') + ' ' + date.toTimeString().substring(0,8)
    }

    public static dateISO(date?: string, time?: string, addDates?: number, addHours?: number, addMinutes?: number, addSeconds?: number){
        var date1 = new Date(date || this.dateCurrent()) //convert to local time 
        if (addDates) date1.setDate(date1.getDate() + addDates);
        if (addHours) date1.setHours(date1.getHours() + addHours);
        if (addMinutes) date1.setMinutes(date1.getMinutes() + addMinutes);
        if (addSeconds) date1.setSeconds(date1.getSeconds() + addSeconds);
        return date1.toLocaleDateString('en-CA') + ' ' + (time || date1.toTimeString().substring(0,8));
    }
    
    public static dateFormat(date: string, format?: string) {
        if (!date) return '';
        
        date = this.dateISO(date); 
        const month = this.months('value');
        const mon = this.months('captionshort');
        const y = date.substring(0,4);
        const m = date.substring(5,7);
        const d = date.substring(8,10);
        const t = date.substring(11,19);
        const h = date.substring(11,13);
        const n = date.substring(14,16);
        const s = date.substring(17,19);
        
        var fmt = format || 'd-m-y';
        fmt = fmt
        .replace('month', '???')
        .replace('mon', '??')
        .replace('m', '?')
        .replace('y',y)
        .replace('d',d)
        .replace('t',t)
        .replace('h',h)
        .replace('n',n)
        .replace('s',s)
        .replace('???', month[+m-1])
        .replace('??', mon[+m-1])
        .replace('?', m)

        return fmt;
    }

    public static dateDiff(from: string, to?: string) {
        const diff =  (to? Date.parse(to) : Date.now()) - Date.parse(from); 
        const dateDiff = new Date(diff);
        const diffYear = dateDiff.getFullYear() - 1970;
        const diffMonth = dateDiff.getMonth();
        const diffYearRounded = diffYear + (diffMonth>6? 1 : 0);

        return isNaN(diff) ? {} : {
            milisecond: dateDiff.getMilliseconds(),
            second:  dateDiff.getSeconds(),
            minute: dateDiff.getMinutes(),
            hour: dateDiff.getHours(),
            day: dateDiff.getDate(),
            month: diffMonth,
            year: diffYear,
            yearrounded: diffYearRounded,
        }
    }

//Currency & Number
    public static thousandSeparator = '.';
    public static decimalSeparator = ',';
    public static currencySymbol = 'Rp';
        
    public static strToNumber(value: string) {
        const v = Number((value || '').toString().replace(/[^0-9,-]/g, _ => ''));
        return isNaN(v)? 0 : v;
    }

    public static strToMoney(value: string) {
        let i = 0;
        const pattern = '###.###.###.###.###'.replaceAll('.', this.thousandSeparator);
        const n = this.strToNumber(value);
        const v = (n < 0? n * - 1 : n).toString();
        const x = (v.length + Math.floor((v.length - 1) / 3));
        const patternNew = pattern.substring(pattern.length - x, pattern.length);
        return (n < 0? '-' : '') + patternNew.replace(/#/g, _ => v[i++] || '');
    }

    public static strPhoneToNumber(value: string) {
        return value.replace(/\D/g, '');
    }

//String
    public static strCapitalize(value: string) {
        return value?.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase());
    }

    public static strPluralize(value: string) {
        value = value.trim();
        return value.slice(-1)==='y'? value.substring(0, value.length-1) + 'ies' : (value + ( value.slice(-1) === 'z'? 'zes': value.slice(-1) === 's'? 'es' : value? 's' : ''));
    }

    public static emailMasking(value: string) {
        return value?.replace(/^(.)(.*)(.@.*)$/, (_, a, b, c) => a + b.replace(/./g, '*') + c);
    }

    public static replaceValue(text: string, value: any) {        
        if (value && text) Object.keys(value).forEach((key) => text = text?.replaceAll('[' +key+ ']', value[key]) );
        return text;
    }
    
    public static randomId(length = 6) {
        return Math.random().toString(36).substring(2, length+2);
    }

    public static svgToString(svg: React.ReactElement) {
        return svg? `data:image/svg+xml,${encodeURIComponent(renderToStaticMarkup(svg))}` : '';
    }

    public static UID() {
        return Math.random().toString(16).slice(2);
    }

//Media    
    public static background(sx: any) {
        const svgName = sx.svgName? `${BackgroundSvg}#${sx.svgName}` : '';
        
        return {
            backgroundSize: sx.size && isNaN(+sx.size)? sx.size : `${sx.size || '100'}%`,
            backgroundImage: `url('${svgName || this.svgToString(sx.svg) || sx.image}')`,   
            backgroundRepeat: 'no-repeat',
            backgroundPosition: sx.position || 'center',
        }
    }

    public static checkIsImage = async(path: string) => {
        const img = new Image();
        img.src = path;
        return new Promise((resolve) => {
            img.onerror = () => resolve(false);
            img.onload = () => resolve(img);
        });
    }

//Array    
    public static JSONParse(data: string) {
        data = data.replace("'",'"');
        var result;
        try { result = JSON.parse(data)} catch (e) { result = JSON.parse(JSON.stringify(data))}
        return result;
    }

    public static mergeArray(array: any, arrayExt: any, deep?: boolean) {
        const isObject = (object: any) => (typeof object === 'object' && object !== null);
        const readObject = (d: any, x: any) => {
            Object.keys(d).map((d1: any) => {
                if (x?.[d1] || x?.[d1] === 0 || x?.[d1] === false) {
                    var dd1 = d[d1];
                    if (isObject(dd1) && isObject(x[d1]))
                        dd1 = this.mergeArray(dd1, x[d1], true);
                    else if (!Array.isArray(dd1) && !Array.isArray(x[d1]))
                        dd1 = x[d1];
                    d = Object.assign({}, d, {[d1]: dd1});
                }
                return d;
            })
            return d;
        }
        
        const joinObject = (d: any, x: any) => {
            return x.reduce((r: any, d1: any) => {
                let f = d.find((d2: any) => d2.id === d1.id);
                r.push(f? {...d1, ...f} : d1);
                return r;
            }, []);
        }

        if (!arrayExt || arrayExt.length === 0) return;
        
        if (!Array.isArray(array) || !Array.isArray(arrayExt))
            return (Object.keys(array).filter((d1: any) => isObject(array[d1])).length>0)?
            readObject(array, arrayExt) : Object.assign({}, array, arrayExt);
        
        return joinObject(array, arrayExt)?.map((d: any, i: number) => {
                const dx: any = arrayExt?.filter((d1: any) => d.id === d1.id)?.[0];
                if (deep || (!deep && dx)) 
                    return readObject(d, dx);
            })
            .filter((d: any) => d !== undefined)
            .sort((a: any, b: any) => (a.seq+1 || a.id) > (b.seq+1 || b.id)? 1 : -1);    
    }

    public static strFieldToArray(fieldName: string, value?: string, obj?: any) {
        const [last, ...fields] = fieldName.split('.').reverse();
        var result = fields.reduce((r: any, d: any) => {return {[d]: r}}, {[last]: value });
        
        if (obj) result = AppService.mergeArray(obj, result);
        return result;
    }
}

